module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4Gcxx"))).then(() => parcelRequire('f4eak'));